export default __webpack_public_path__ + "static/media/giftcard-generic-badge.8feee6a6.png";